__webpack_require__.p = "/candidate-dialog-nav/referrals-hub/";